import { render, staticRenderFns } from "./Mbti.vue?vue&type=template&id=7a14df45&scoped=true&"
import script from "./Mbti.vue?vue&type=script&lang=js&"
export * from "./Mbti.vue?vue&type=script&lang=js&"
import style0 from "./Mbti.vue?vue&type=style&index=0&id=7a14df45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a14df45",
  null
  
)

export default component.exports